<template>
  <q-menu
    target=".input-target-chat"
    :value="open"
    no-parent-event
    no-focus
    max-width="55vw"
    max-height="40vh"
  >
    <q-list class="full-width list-commands">
      <template v-for="(option, index) in options">
        <q-item
          :data-testid="`chat-comando-${option.id}`"
          :key="`item-${option.id}`"
          clickable
          @click="onClick(index)"
          :class="[option.class || 'option-without', index === selected ? 'is-active' : '']"
        >
          <q-item-section>
            <q-item-label>
              <span
                ref="options"
                class="option-bold"
                v-if="option.label"
              >{{ option.label }}</span>
              <span
                class="text-grey-8"
                v-if="option.option"
              > {{ option.option }}</span>
            </q-item-label>

            <q-item-label
              caption
              v-if="option.description"
            >
              {{ option.description }}
            </q-item-label>
          </q-item-section>

          <q-item-section
            side
            v-if="hasSubOptions(option)"
          >
            <q-icon
              dense
              name="mdi-arrow-right"
            />
          </q-item-section>
        </q-item>
        <q-separator :key="`separator-${option.id}`" />
      </template>
    </q-list>
  </q-menu>
</template>

<script>
export default {
  props: {
    open: {},
    value: {},
    options: {}
  },

  data () {
    return {
      selected: isNaN(this.value) || 0
    }
  },

  methods: {
    onClick (selected) {
      const vm = this
      vm.$emit('on-click', selected)
    },

    hasSubOptions: (option) => Boolean(option?.options?.length)
  },

  watch: {
    value: {
      deep: true,
      handler (selected) {
        const vm = this
        if (selected === vm.selected) return

        const lenOptions = vm.$refs.options?.length || 0
        if (!lenOptions) return

        vm.selected = selected
        vm.$refs.options[selected].scrollIntoView()
      }
    },

    selected: {
      deep: true,
      handler (selected) {
        if (selected === this.value) return
        this.$emit('input', selected)
      }
    }
  }
}

</script>

<style lang="sass">
.list-commands
  background-color: #fff

  .option-category
    background-color: #e4f4ff

    &.is-active
      background-color: #b2dfff

  .option-command
    background-color: #ffe7d7

    &.is-active
      background-color: #ffc7a1

  .option-without
    background-color: #fff

    &.is-active
      background-color: #dbdbdb

  .is-active
    span.option-bold
      font-weight: bold
</style>
